export default __webpack_public_path__ + "static/media/Undo.e3044844.svg";